"use client";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertCircle, AlertTriangle, Ban, Check, ChevronDown, ChevronLeft, ChevronRight, Code, Copy, Eye, Gift, Globe, MessageSquare, Wrench, Zap, Search, Filter, X, ArrowUpDown, ArrowUp, ArrowDown, Video, ImagePlus, ExternalLink, Gem, Percent, Scale, Braces, FileJson2, List, Grid, Bot, Boxes, Brain, Sparkles, PenTool, Sliders, Volume2, Mic, ListOrdered, SlidersHorizontal, Clock } from "lucide-react";
import Link from "next/link.js";
import { usePathname, useRouter, useSearchParams } from "next/navigation.js";
import React, { useMemo, useState, useCallback, useEffect, useDeferredValue } from "react";
import { getProviderIcon } from "../provider-icons.js";
import { Badge } from "../ui/badge.js";
import { Button } from "../ui/button.js";
import { Card, CardContent } from "../ui/card.js";
import { Input } from "../ui/input.js";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select.js";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table.js";
import { Toggle } from "../ui/toggle.js";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip.js";
import { getMappingStatus, isModelMappingStatus, shouldShowDeactivationNotice } from "../../deactivation.js";
import { discountFraction } from "../../lib/discount.js";
import { cn } from "../../lib/utils.js";
import { expandVirtualModels } from "@llmgateway/models";
import { matchesCapability, matchesOutputCapabilities } from "./capability-filters.js";
import { formatDeprecationDate, formatPerImagePriceRange, formatPerSecondPriceLabel, formatPerUnitPrice } from "./format.js";
import { ModelCard } from "./model-card.js";
import { applyCategoryFilter } from "./model-category-filters.js";
import { compareSortValues, effectiveTokenPrice, getInputAudioHourPrice, getInputCharacterPricePer1K, getMaxPerSecondPrice, getMinPerSecondPrice, hasPaidTier, inputPriceInUnit, isPriceUnitField, minUnitPrice, outputPriceInUnit, parseStrictPrice, PRICE_UNIT_FIELDS } from "./pricing-schedule.js";
import { isVisibleMapping } from "./status-filters.js";
import { applyUseCaseFilter, getExcludedCapabilityKeys, getImpliedCapabilityKeys, isUseCaseCategory, providerRowPassesFilters } from "./use-case-filters.js";
import { useIsMobile } from "./use-mobile.js";
var PRICE_UNIT_OPTIONS = [{
  field: "perImagePrice",
  Icon: ImagePlus,
  iconClass: "text-pink-500",
  name: "Image",
  unit: "$/image"
}, {
  field: "perSecondPrice",
  Icon: Video,
  iconClass: "text-violet-500",
  name: "Video",
  unit: "$/sec"
}, {
  field: "inputCharacterPrice",
  Icon: Volume2,
  iconClass: "text-rose-500",
  name: "Speech",
  unit: "$/1K chars"
}, {
  field: "inputAudioHourPrice",
  Icon: Mic,
  iconClass: "text-sky-500",
  name: "Transcription",
  unit: "$/hour"
}];
function addedAtMs(model) {
  var _a;
  var addedAt = (_a = model.createdAt) !== null && _a !== void 0 ? _a : model.releasedAt;
  return addedAt ? new Date(addedAt).getTime() : 0;
}
function compareNewestFirst(a, b) {
  return addedAtMs(b) - addedAtMs(a) || a.id.localeCompare(b.id);
}
function minAcross(items, value) {
  var values = items.map(value).filter(function (v) {
    return v !== null;
  });
  return values.length > 0 ? Math.min.apply(Math, values) : null;
}
function withinBounds(value, min, max) {
  if (value === null) {
    return !min && !max;
  }
  var minPrice = min ? parseFloat(min) : -Infinity;
  var maxPrice = max ? parseFloat(max) : Infinity;
  return value >= minPrice && value <= maxPrice;
}
function computeCapabilities(provider, model) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var capabilities = [];
  if (provider.streaming) {
    capabilities.push({
      icon: Zap,
      label: "Streaming",
      color: "text-blue-500"
    });
  }
  if (provider.vision) {
    capabilities.push({
      icon: Eye,
      label: "Vision",
      color: "text-green-500"
    });
  }
  if (provider.tools) {
    capabilities.push({
      icon: Wrench,
      label: "Tools",
      color: "text-purple-500"
    });
  }
  if (provider.reasoning) {
    capabilities.push({
      icon: MessageSquare,
      label: "Reasoning",
      color: "text-orange-500"
    });
  }
  if (provider.reasoningMaxTokens) {
    capabilities.push({
      icon: Sliders,
      label: "Reasoning Budget",
      color: "text-amber-500"
    });
  }
  if (provider.jsonOutput) {
    capabilities.push({
      icon: Braces,
      label: "JSON Output",
      color: "text-cyan-500"
    });
  }
  if (provider.jsonOutputSchema) {
    capabilities.push({
      icon: FileJson2,
      label: "Structured JSON",
      color: "text-teal-500"
    });
  }
  if ((_a = model === null || model === void 0 ? void 0 : model.output) === null || _a === void 0 ? void 0 : _a.includes("image")) {
    capabilities.push({
      icon: ImagePlus,
      label: "Image Generation",
      color: "text-pink-500"
    });
  }
  if ((_b = model === null || model === void 0 ? void 0 : model.output) === null || _b === void 0 ? void 0 : _b.includes("video")) {
    capabilities.push({
      icon: Video,
      label: "Video Generation",
      color: "text-violet-500"
    });
  }
  if ((_c = model === null || model === void 0 ? void 0 : model.output) === null || _c === void 0 ? void 0 : _c.includes("audio")) {
    capabilities.push({
      icon: Volume2,
      label: "Speech Generation",
      color: "text-rose-500"
    });
  }
  if ((_d = model === null || model === void 0 ? void 0 : model.output) === null || _d === void 0 ? void 0 : _d.includes("transcription")) {
    capabilities.push({
      icon: Mic,
      label: "Transcription",
      color: "text-sky-500"
    });
  }
  if ((_e = model === null || model === void 0 ? void 0 : model.output) === null || _e === void 0 ? void 0 : _e.includes("embedding")) {
    capabilities.push({
      icon: Boxes,
      label: "Embeddings",
      color: "text-indigo-500"
    });
  }
  if ((_f = model === null || model === void 0 ? void 0 : model.output) === null || _f === void 0 ? void 0 : _f.includes("rerank")) {
    capabilities.push({
      icon: ListOrdered,
      label: "Rerank",
      color: "text-amber-500"
    });
  }
  if ((_g = model === null || model === void 0 ? void 0 : model.output) === null || _g === void 0 ? void 0 : _g.includes("decision")) {
    capabilities.push({
      icon: SlidersHorizontal,
      label: "Decisions",
      color: "text-teal-500"
    });
  }
  if ((_h = model === null || model === void 0 ? void 0 : model.output) === null || _h === void 0 ? void 0 : _h.includes("search")) {
    capabilities.push({
      icon: Search,
      label: "Search API",
      color: "text-sky-500"
    });
  }
  if (provider.webSearch) {
    capabilities.push({
      icon: Globe,
      label: "Web Search",
      color: "text-sky-500"
    });
  }
  return capabilities;
}
var CAPABILITY_LABEL_BY_FILTER_KEY = {
  streaming: "Streaming",
  vision: "Vision",
  tools: "Tools",
  reasoning: "Reasoning",
  reasoningBudget: "Reasoning Budget",
  jsonOutput: "JSON Output",
  jsonOutputSchema: "Structured JSON",
  imageGeneration: "Image Generation",
  videoGeneration: "Video Generation",
  audioGeneration: "Speech Generation",
  transcription: "Transcription",
  embedding: "Embeddings",
  rerank: "Rerank",
  decisions: "Decisions",
  searchApi: "Search API",
  webSearch: "Web Search"
};
function shouldShowStabilityWarning(stability) {
  return stability !== null && stability !== undefined && ["unstable", "experimental"].includes(stability);
}
function formatPrice(price, discount) {
  var priceNum = parseStrictPrice(price);
  if (priceNum === null) {
    return "—";
  }
  var discountNum = discountFraction(discount);
  var originalPrice = (priceNum * 1e6).toFixed(2);
  if (discountNum > 0) {
    var discountedPrice = (priceNum * 1e6 * (1 - discountNum)).toFixed(2);
    return _jsxs("div", {
      className: "flex flex-col items-end",
      children: [_jsxs("div", {
        className: "flex items-center gap-1",
        children: [_jsxs("span", {
          className: "line-through text-muted-foreground text-xs",
          children: ["$", originalPrice]
        }), _jsxs("span", {
          className: "text-green-600 font-semibold",
          children: ["$", discountedPrice]
        })]
      }), _jsxs("span", {
        className: "text-[10px] text-green-600",
        children: ["-", Math.round(discountNum * 100), "% off"]
      })]
    });
  }
  return "$".concat(originalPrice);
}
var ModelTableRow = React.memo(function (_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
  var row = _a.row,
    isExpanded = _a.isExpanded,
    copiedModel = _a.copiedModel,
    onToggleExpand = _a.onToggleExpand,
    onCopy = _a.onCopy,
    onNavigate = _a.onNavigate,
    formatPrice = _a.formatPrice,
    modelHref = _a.modelHref,
    pinnedCapabilityKeys = _a.pinnedCapabilityKeys,
    showLoungePlan = _a.showLoungePlan;
  var ProviderIcon = row.ProviderIcon;
  var isCustom = row.model.source === "custom";
  var blockedReasons = (_b = row.provider.blockedReasons) !== null && _b !== void 0 ? _b : [];
  var isBlocked = blockedReasons.length > 0;
  var showDeactivationNotice = shouldShowDeactivationNotice(row.provider);
  var mappingStatus = getMappingStatus(row.provider);
  var isScheduled = mappingStatus === "scheduled";
  var inputTokenPrice = effectiveTokenPrice(row.provider.inputPrice, row.provider.discount);
  var outputTokenPrice = effectiveTokenPrice(row.provider.outputPrice, row.provider.discount);
  var minPerSecond = getMinPerSecondPrice(row.provider);
  var maxPerSecond = getMaxPerSecondPrice(row.provider);
  var perThousandChars = getInputCharacterPricePer1K(row.provider);
  var hasCharacterPricing = ((_c = parseStrictPrice(row.provider.inputCharacterPrice)) !== null && _c !== void 0 ? _c : 0) > 0;
  var ocrPagePrice = (_d = parseStrictPrice(row.provider.ocrPagePrice)) !== null && _d !== void 0 ? _d : 0;
  var ocrPerThousandPages = ocrPagePrice > 0 && !inputTokenPrice && !outputTokenPrice ? ocrPagePrice * 1000 * (1 - discountFraction(row.provider.discount)) : null;
  var perSecondPrices = row.provider.perSecondPrice;
  var perSecondLabel = perSecondPrices ? (_f = (_e = formatPerSecondPriceLabel(perSecondPrices, row.provider.discount)) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : minPerSecond !== null ? formatPerUnitPrice(minPerSecond) : null : null;
  var audioHourPrice = getInputAudioHourPrice(row.provider);
  return _jsxs(_Fragment, {
    children: [_jsxs(TableRow, {
      className: cn("hover:bg-muted/50 transition-colors", isCustom ? "cursor-default" : "cursor-pointer", isBlocked && "opacity-60"),
      onClick: function () {
        return onNavigate(row);
      },
      children: [_jsx(TableCell, {
        className: "font-medium",
        children: _jsxs("div", {
          className: "flex items-center gap-2",
          children: [row.hasAdditionalPricing ? _jsx("button", {
            onClick: function (e) {
              e.stopPropagation();
              onToggleExpand(row.rowKey);
            },
            className: "p-0.5 hover:bg-muted rounded",
            "aria-label": "Toggle additional pricing details",
            "aria-expanded": isExpanded,
            children: isExpanded ? _jsx(ChevronDown, {
              className: "h-4 w-4 text-muted-foreground"
            }) : _jsx(ChevronRight, {
              className: "h-4 w-4 text-muted-foreground"
            })
          }) : _jsx("div", {
            className: "w-5 h-5"
          }), ProviderIcon ? _jsx(ProviderIcon, {
            className: "w-4 h-4"
          }) : _jsx("div", {
            className: "w-4 h-4 rounded-sm flex items-center justify-center text-xs font-medium text-white",
            style: {
              backgroundColor: (_h = (_g = row.providerInfo) === null || _g === void 0 ? void 0 : _g.color) !== null && _h !== void 0 ? _h : "#6b7280"
            },
            children: ((_k = (_j = row.providerInfo) === null || _j === void 0 ? void 0 : _j.name) !== null && _k !== void 0 ? _k : row.provider.providerId).charAt(0).toUpperCase()
          }), isCustom ? _jsx("span", {
            className: "text-sm",
            children: (_m = (_l = row.providerInfo) === null || _l === void 0 ? void 0 : _l.name) !== null && _m !== void 0 ? _m : row.provider.providerId
          }) : _jsxs(Link, {
            href: modelHref("/models/".concat(encodeURIComponent(row.model.id), "/").concat(row.provider.providerId)),
            onClick: function (e) {
              return e.stopPropagation();
            },
            className: "text-sm hover:text-primary hover:underline",
            children: [(_p = (_o = row.providerInfo) === null || _o === void 0 ? void 0 : _o.name) !== null && _p !== void 0 ? _p : row.provider.providerId, row.provider.region && _jsxs("span", {
              className: "text-muted-foreground text-xs ml-1",
              children: ["(", row.provider.region, ")"]
            })]
          }), isCustom && _jsx(Badge, {
            variant: "outline",
            className: "text-[10px] px-1.5 py-0 shrink-0",
            children: "Custom"
          }), isBlocked && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx("span", {
                className: "shrink-0 cursor-help",
                children: _jsx(Ban, {
                  className: "h-3.5 w-3.5 text-red-500"
                })
              })
            }), _jsxs(TooltipContent, {
              className: "max-w-xs",
              children: [_jsx("p", {
                className: "text-xs font-medium mb-1",
                children: "Not available under your organization's compliance policy:"
              }), _jsx("ul", {
                className: cn("text-xs", blockedReasons.length > 1 && "list-disc pl-4 space-y-0.5"),
                children: blockedReasons.map(function (reason) {
                  return _jsx("li", {
                    children: reason
                  }, reason);
                })
              })]
            })]
          }), showDeactivationNotice && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx("span", {
                className: "shrink-0 cursor-help",
                children: isScheduled ? _jsx(Clock, {
                  className: "h-3.5 w-3.5 text-amber-500"
                }) : _jsx(AlertCircle, {
                  className: "h-3.5 w-3.5 text-red-500"
                })
              })
            }), _jsx(TooltipContent, {
              children: _jsx("p", {
                className: "text-xs",
                children: formatDeprecationDate(row.provider.deactivatedAt, "deactivated")
              })
            })]
          }), !showDeactivationNotice && row.provider.deprecatedAt && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx("span", {
                className: "shrink-0 cursor-help",
                children: _jsx(AlertTriangle, {
                  className: "h-3.5 w-3.5 text-amber-500"
                })
              })
            }), _jsx(TooltipContent, {
              children: _jsx("p", {
                className: "text-xs",
                children: formatDeprecationDate(row.provider.deprecatedAt, "deprecated")
              })
            })]
          }), !isCustom && _jsx(ExternalLink, {
            className: "h-3 w-3 text-muted-foreground"
          })]
        })
      }), _jsx(TableCell, {
        children: _jsxs("div", {
          className: "flex items-center gap-2",
          children: [isCustom ? _jsx("span", {
            className: "font-medium text-sm",
            children: row.model.id
          }) : _jsx(Link, {
            href: modelHref("/models/".concat(encodeURIComponent(row.model.id))),
            onClick: function (e) {
              return e.stopPropagation();
            },
            className: "font-medium text-sm hover:text-primary hover:underline",
            children: row.model.id
          }), row.model.virtualModelTarget && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx(Badge, {
                variant: "outline",
                className: "shrink-0 text-[10px]",
                tabIndex: 0,
                children: "Virtual"
              })
            }), _jsx(TooltipContent, {
              children: _jsxs("p", {
                children: ["Currently ", row.model.virtualModelTarget, ". The served version and pricing may change."]
              })
            })]
          }), row.model.premium && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx("span", {
                className: "shrink-0 cursor-help",
                children: _jsx(Gem, {
                  className: "h-3.5 w-3.5 text-amber-500"
                })
              })
            }), _jsx(TooltipContent, {
              children: _jsx("p", {
                className: "text-xs",
                children: "Premium tier / $5+/M input or $15+/M output after public discounts. Subject to the weekly fair-use allowance on DevPass plans."
              })
            })]
          }), showLoungePlan && row.model.loungePlan === "plus" && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsxs("span", {
                tabIndex: 0,
                className: "shrink-0 cursor-help rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                children: [_jsx(Badge, {
                  variant: "outline",
                  className: "px-1.5 py-0 text-[10px] font-medium text-amber-600 dark:text-amber-400",
                  children: "Plus"
                }), _jsx("span", {
                  className: "sr-only",
                  children: ": needs a Lounge Plus or Pro membership"
                })]
              })
            }), _jsx(TooltipContent, {
              children: _jsx("p", {
                className: "text-xs",
                children: "Frontier model. In Lounge it needs a Plus or Pro membership; Starter doesn't include it."
              })
            })]
          }), _jsx("button", {
            onClick: function (e) {
              var fullId = isCustom ? row.model.id : row.provider.region ? "".concat(row.provider.providerId, "/").concat(row.model.id, ":").concat(row.provider.region) : "".concat(row.provider.providerId, "/").concat(row.model.id);
              onCopy(fullId, row.rowKey, e);
            },
            className: "p-1 hover:bg-muted rounded transition-colors",
            title: copiedModel === row.rowKey ? "Copied!" : "Copy model ID",
            children: copiedModel === row.rowKey ? _jsx(Check, {
              className: "h-3 w-3 text-green-500"
            }) : _jsx(Copy, {
              className: "h-3 w-3 text-muted-foreground"
            })
          })]
        })
      }), _jsx(TableCell, {
        className: "text-right font-mono text-sm",
        children: minPerSecond !== null && !inputTokenPrice ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsxs("span", {
              className: "text-violet-500 cursor-help",
              children: [formatPerUnitPrice(minPerSecond), "/sec"]
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Video per-second pricing"
            })
          })]
        }) : ocrPerThousandPages !== null ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsxs("span", {
              className: "text-sky-500 cursor-help",
              children: ["$", ocrPerThousandPages.toFixed(2), "/1K pages"]
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Per-page OCR pricing (not per token)"
            })
          })]
        }) : hasCharacterPricing && perThousandChars !== null && !inputTokenPrice ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsxs("span", {
              className: "text-sky-500 cursor-help",
              children: [formatPerUnitPrice(perThousandChars), "/1K chars"]
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Per-character pricing (not per token)"
            })
          })]
        }) : (!row.provider.inputPrice || parseFloat(row.provider.inputPrice) === 0) && row.provider.requestPrice && parseFloat(row.provider.requestPrice) > 0 ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsxs("span", {
              className: "text-amber-500 cursor-help",
              children: ["$", parseFloat(row.provider.requestPrice).toFixed(3), "/req"]
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Per-request pricing (not per token)"
            })
          })]
        }) : (!row.provider.inputPrice || parseFloat(row.provider.inputPrice) === 0) && row.provider.perImagePrice && Object.keys(row.provider.perImagePrice).length > 0 ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsx("span", {
              className: "text-amber-500 cursor-help",
              children: function () {
                var range = formatPerImagePriceRange(row.provider.perImagePrice, row.provider.discount);
                return range ? "".concat(range, "/image") : "—";
              }()
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Per-image pricing by output resolution (not per token)"
            })
          })]
        }) : audioHourPrice !== null && !inputTokenPrice ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsxs("span", {
              className: "text-sky-500 cursor-help",
              children: [formatPerUnitPrice(audioHourPrice), "/hour"]
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Audio transcription per-hour pricing (not per token)"
            })
          })]
        }) : formatPrice(row.provider.inputPrice, row.provider.discount)
      }), _jsx(TableCell, {
        className: "text-right font-mono text-sm",
        children: maxPerSecond !== null && !outputTokenPrice ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsxs("span", {
              className: "text-violet-500 cursor-help",
              children: [formatPerUnitPrice(maxPerSecond), "/sec"]
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Video per-second pricing"
            })
          })]
        }) : ocrPerThousandPages !== null || (!row.provider.outputPrice || parseFloat(row.provider.outputPrice) === 0) && (row.provider.requestPrice && parseFloat(row.provider.requestPrice) > 0 || row.provider.perImagePrice && Object.keys(row.provider.perImagePrice).length > 0 || row.provider.inputCharacterPrice && parseFloat(row.provider.inputCharacterPrice) > 0 || audioHourPrice !== null) ? _jsx("span", {
          className: "text-muted-foreground",
          children: "\u2014"
        }) : formatPrice(row.provider.outputPrice, row.provider.discount)
      }), _jsx(TableCell, {
        className: "text-right font-mono text-sm",
        children: formatPrice(row.provider.cachedInputPrice, row.provider.discount)
      }), _jsx(TableCell, {
        className: "text-center",
        children: function () {
          var pinnedLabels = pinnedCapabilityKeys.map(function (key) {
            return CAPABILITY_LABEL_BY_FILTER_KEY[key];
          }).filter(function (label) {
            return Boolean(label);
          });
          var ordered = __spreadArray(__spreadArray([], pinnedLabels.map(function (label) {
            return row.capabilities.find(function (c) {
              return c.label === label;
            });
          }).filter(function (c) {
            return Boolean(c);
          }), true), row.capabilities.filter(function (c) {
            return !pinnedLabels.includes(c.label);
          }), true);
          var visible = ordered.slice(0, 4);
          var overflow = ordered.slice(4);
          return _jsxs("div", {
            className: "flex justify-center gap-1",
            children: [visible.map(function (_a) {
              var Icon = _a.icon,
                label = _a.label,
                color = _a.color;
              return _jsx("div", {
                className: "p-0.5",
                title: label,
                children: _jsx(Icon, {
                  className: "h-4 w-4 ".concat(color)
                })
              }, label);
            }), overflow.length > 0 && _jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsxs("button", {
                  className: "p-0.5 text-xs font-medium text-muted-foreground",
                  onClick: function (e) {
                    return e.stopPropagation();
                  },
                  children: ["+", overflow.length]
                })
              }), _jsx(TooltipContent, {
                children: _jsx("div", {
                  className: "flex flex-col gap-1 text-xs",
                  children: overflow.map(function (_a) {
                    var Icon = _a.icon,
                      label = _a.label;
                    return _jsxs("span", {
                      className: "flex items-center gap-1.5",
                      children: [_jsx(Icon, {
                        className: "h-4 w-4 text-background"
                      }), label]
                    }, label);
                  })
                })
              })]
            })]
          });
        }()
      })]
    }), isExpanded && row.hasAdditionalPricing && _jsx(TableRow, {
      className: "bg-muted/30",
      children: _jsx(TableCell, {
        colSpan: 6,
        className: "py-3",
        children: _jsxs("div", {
          className: "pl-8",
          children: [_jsx("div", {
            className: "text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-2",
            children: "Additional Pricing"
          }), _jsxs("div", {
            className: "flex gap-3",
            children: [row.provider.webSearch && _jsxs(Badge, {
              variant: "outline",
              className: "text-sm px-3 py-1.5 bg-background",
              children: [_jsx(Globe, {
                className: "h-4 w-4 mr-2 text-purple-500"
              }), "Web Search", row.provider.webSearchPrice && parseFloat(row.provider.webSearchPrice) > 0 && " $".concat(parseFloat(row.provider.webSearchPrice).toFixed(3), "/search")]
            }), row.provider.requestPrice && parseFloat(row.provider.requestPrice) > 0 && _jsxs(Badge, {
              variant: "outline",
              className: "text-sm px-3 py-1.5 bg-background",
              children: ["Per Request $", parseFloat(row.provider.requestPrice).toFixed(3)]
            }), perSecondLabel !== null && _jsxs(Badge, {
              variant: "outline",
              className: "text-sm px-3 py-1.5 bg-background",
              children: [_jsx(Video, {
                className: "h-4 w-4 mr-2 text-violet-500"
              }), "Video ", perSecondLabel, "/sec"]
            }), row.provider.perImagePrice && Object.keys(row.provider.perImagePrice).length > 0 && _jsxs(Badge, {
              variant: "outline",
              className: "text-sm px-3 py-1.5 bg-background",
              children: ["Per Image", " ", (_q = formatPerImagePriceRange(row.provider.perImagePrice, row.provider.discount)) !== null && _q !== void 0 ? _q : ""]
            })]
          })]
        })
      })
    })]
  });
});
var GridModelCard = React.memo(function (_a) {
  var model = _a.model,
    onNavigate = _a.onNavigate,
    renderCta = _a.renderCta;
  return _jsx(ModelCard, {
    shouldShowStabilityWarning: shouldShowStabilityWarning,
    getCapabilityIcons: computeCapabilities,
    model: model,
    goToModel: function () {
      return onNavigate(model);
    },
    formatPrice: formatPrice,
    renderCta: renderCta
  });
});
var TABLE_ROWS_PER_PAGE = 50;
var GRID_MODELS_PER_PAGE = 12;
export function AllModels(_a) {
  var _this = this;
  var _b, _c;
  var children = _a.children,
    catalogue = _a.models,
    providers = _a.providers,
    title = _a.title,
    description = _a.description,
    categoryFilter = _a.categoryFilter,
    seoContent = _a.seoContent,
    footer = _a.footer,
    renderCta = _a.renderCta,
    _d = _a.modelHrefBase,
    modelHrefBase = _d === void 0 ? "" : _d,
    _e = _a.showPricingTierFilter,
    showPricingTierFilter = _e === void 0 ? false : _e,
    _f = _a.showLoungePlanFilter,
    showLoungePlanFilter = _f === void 0 ? false : _f,
    _g = _a.defaultCategory,
    defaultCategory = _g === void 0 ? "all" : _g,
    _h = _a.hideUseCaseFilter,
    hideUseCaseFilter = _h === void 0 ? false : _h,
    _j = _a.hideHeader,
    hideHeader = _j === void 0 ? false : _j;
  var models = useMemo(function () {
    return expandVirtualModels(catalogue);
  }, [catalogue]);
  var router = useRouter();
  var pathname = usePathname();
  var searchParams = useSearchParams();
  var isMobile = useIsMobile();
  var modelHref = useCallback(function (path) {
    return "".concat(modelHrefBase).concat(path);
  }, [modelHrefBase]);
  var _k = useState(searchParams.get("view") === "grid" ? "grid" : "table"),
    viewMode = _k[0],
    setViewMode = _k[1];
  useEffect(function () {
    var viewParam = searchParams.get("view");
    if (!viewParam && isMobile && viewMode !== "grid") {
      setViewMode("grid");
    }
  }, [isMobile, searchParams, viewMode]);
  var _l = useState(new Set()),
    expandedRows = _l[0],
    setExpandedRows = _l[1];
  var _m = useState(null),
    copiedModel = _m[0],
    setCopiedModel = _m[1];
  var _o = useState((_b = searchParams.get("q")) !== null && _b !== void 0 ? _b : ""),
    searchQuery = _o[0],
    setSearchQuery = _o[1];
  var deferredSearchQuery = useDeferredValue(searchQuery);
  var _p = useState(searchParams.get("filters") === "1"),
    showFilters = _p[0],
    setShowFilters = _p[1];
  var sortFieldParam = searchParams.get("sortField");
  var sortDirParam = searchParams.get("sortDir");
  var discountedDefault = categoryFilter === "discounted" && !sortFieldParam && !sortDirParam;
  var _q = useState(sortFieldParam || (discountedDefault ? "discount" : null)),
    sortField = _q[0],
    setSortField = _q[1];
  var _r = useState(sortDirParam === "desc" || sortDirParam === "asc" ? sortDirParam : discountedDefault ? "desc" : "asc"),
    sortDirection = _r[0],
    setSortDirection = _r[1];
  var urlCategory = searchParams.get("category");
  function getStatusFilterFromUrl(searchParams_0) {
    var status = searchParams_0.get("status");
    if (status && isModelMappingStatus(status) && status !== "active") {
      return status;
    }
    return searchParams_0.get("deactivated") === "true" ? "deactivated" : null;
  }
  var _s = useState(function () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      var category = hideUseCaseFilter ? defaultCategory : isUseCaseCategory(urlCategory) ? urlCategory : defaultCategory;
      var capabilities = {
        streaming: searchParams.get("streaming") === "true",
        vision: searchParams.get("vision") === "true",
        tools: searchParams.get("tools") === "true",
        reasoning: searchParams.get("reasoning") === "true",
        reasoningBudget: searchParams.get("reasoningBudget") === "true",
        jsonOutput: searchParams.get("jsonOutput") === "true",
        jsonOutputSchema: searchParams.get("jsonOutputSchema") === "true",
        imageGeneration: searchParams.get("imageGeneration") === "true",
        videoGeneration: searchParams.get("videoGeneration") === "true",
        audioGeneration: searchParams.get("audioGeneration") === "true",
        transcription: searchParams.get("transcription") === "true",
        embedding: searchParams.get("embedding") === "true",
        rerank: searchParams.get("rerank") === "true",
        decisions: searchParams.get("decisions") === "true",
        searchApi: searchParams.get("searchApi") === "true",
        webSearch: searchParams.get("webSearch") === "true",
        free: searchParams.get("free") === "true",
        discounted: searchParams.get("discounted") === "true"
      };
      for (var _i = 0, _l = getExcludedCapabilityKeys(category); _i < _l.length; _i++) {
        var key = _l[_i];
        if (key in capabilities) {
          capabilities[key] = false;
        }
      }
      return {
        category: category,
        tier: (_a = searchParams.get("tier")) !== null && _a !== void 0 ? _a : "all",
        loungePlan: showLoungePlanFilter ? (_b = searchParams.get("lounge")) !== null && _b !== void 0 ? _b : "all" : "all",
        capabilities: capabilities,
        selectedProvider: (_c = searchParams.get("provider")) !== null && _c !== void 0 ? _c : "all",
        status: getStatusFilterFromUrl(searchParams),
        source: (_d = searchParams.get("source")) !== null && _d !== void 0 ? _d : "all",
        eligibleOnly: searchParams.get("eligibility") === "eligible",
        inputPrice: {
          min: (_e = searchParams.get("inputPriceMin")) !== null && _e !== void 0 ? _e : "",
          max: (_f = searchParams.get("inputPriceMax")) !== null && _f !== void 0 ? _f : ""
        },
        outputPrice: {
          min: (_g = searchParams.get("outputPriceMin")) !== null && _g !== void 0 ? _g : "",
          max: (_h = searchParams.get("outputPriceMax")) !== null && _h !== void 0 ? _h : ""
        },
        contextSize: {
          min: (_j = searchParams.get("contextSizeMin")) !== null && _j !== void 0 ? _j : "",
          max: (_k = searchParams.get("contextSizeMax")) !== null && _k !== void 0 ? _k : ""
        },
        priceUnit: function () {
          var v = searchParams.get("priceUnit");
          return isPriceUnitField(v) ? v : null;
        }()
      };
    }),
    filters = _s[0],
    setFilters = _s[1];
  var urlLoungePlan = showLoungePlanFilter ? (_c = searchParams.get("lounge")) !== null && _c !== void 0 ? _c : "all" : "all";
  var urlShowFilters = searchParams.get("filters") === "1";
  useEffect(function () {
    setFilters(function (prev) {
      return prev.loungePlan === urlLoungePlan ? prev : __assign(__assign({}, prev), {
        loungePlan: urlLoungePlan
      });
    });
  }, [urlLoungePlan]);
  useEffect(function () {
    if (urlShowFilters) {
      setShowFilters(true);
    }
  }, [urlShowFilters]);
  var hasCustomModels = useMemo(function () {
    return models.some(function (model) {
      return model.source === "custom";
    });
  }, [models]);
  var hasBlockedMappings = useMemo(function () {
    return models.some(function (model) {
      return model.mappings.some(function (mapping) {
        var _a;
        return (_a = mapping.blockedReasons) === null || _a === void 0 ? void 0 : _a.length;
      });
    });
  }, [models]);
  var hasPerUnitData = useMemo(function () {
    var inScope = function (model) {
      return (!categoryFilter || applyCategoryFilter(categoryFilter, model, model.mappings)) && (!filters.category || filters.category === "all" || applyUseCaseFilter(filters.category, model, model.mappings));
    };
    return models.some(function (model) {
      return inScope(model) && model.mappings.some(function (mapping) {
        return PRICE_UNIT_FIELDS.some(function (unit) {
          return minUnitPrice(mapping, unit) !== null;
        });
      });
    });
  }, [models, categoryFilter, filters.category]);
  var priceUnit = hasPerUnitData ? filters.priceUnit : null;
  var priceUnitOption = PRICE_UNIT_OPTIONS.find(function (option) {
    return option.field === priceUnit;
  });
  var updateUrlWithFilters = useCallback(function (newParams) {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    Object.entries(newParams).forEach(function (_a) {
      var key = _a[0],
        value = _a[1];
      if (value !== undefined && value !== "") {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    window.history.replaceState(null, "", url);
  }, []);
  var setStatusFilter = useCallback(function (status) {
    setFilters(function (prev) {
      return __assign(__assign({}, prev), {
        status: status
      });
    });
    updateUrlWithFilters({
      status: status !== null && status !== void 0 ? status : undefined,
      deactivated: undefined,
      page: undefined
    });
  }, [updateUrlWithFilters]);
  var _t = useMemo(function () {
      var now = new Date();
      var visibleModelCount = models.filter(function (model) {
        return model.mappings.some(function (mapping) {
          return isVisibleMapping(mapping, {
            status: filters.status,
            showDeactivated: false,
            eligibleOnly: filters.eligibleOnly
          }, now);
        });
      }).length;
      return {
        totalModelCount: visibleModelCount,
        totalProviderCount: providers.length
      };
    }, [models, providers, filters.status, filters.eligibleOnly]),
    totalModelCount = _t.totalModelCount,
    totalProviderCount = _t.totalProviderCount;
  var modelsWithProviders = useMemo(function () {
    var now = new Date();
    var baseModels = models.filter(function (model) {
      if (filters.source === "custom") {
        return model.source === "custom";
      }
      if (filters.source === "catalog") {
        return model.source !== "custom";
      }
      return true;
    }).map(function (model) {
      var visibleMappings = model.mappings.filter(function (mapping) {
        return isVisibleMapping(mapping, {
          status: filters.status,
          showDeactivated: false,
          eligibleOnly: filters.eligibleOnly
        }, now);
      });
      return __assign(__assign({}, model), {
        providerDetails: visibleMappings.map(function (mapping) {
          return {
            provider: mapping,
            providerInfo: providers.find(function (p) {
              return p.id === mapping.providerId;
            })
          };
        })
      });
    }).filter(function (model) {
      return model.providerDetails.length > 0;
    });
    var preFilteredModels = categoryFilter ? baseModels.filter(function (model) {
      return applyCategoryFilter(categoryFilter, model, model.providerDetails.map(function (p) {
        return p.provider;
      }));
    }) : baseModels;
    var filteredModels = preFilteredModels.filter(function (model) {
      var _a, _b, _c;
      if (deferredSearchQuery) {
        var normalize = function (str) {
          return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
        };
        var queryTokens = deferredSearchQuery.trim().toLowerCase().split(/\s+/).map(function (t) {
          return t.replace(/[^a-z0-9]/g, "");
        }).filter(Boolean);
        var providerStrings = ((_a = model.providerDetails) !== null && _a !== void 0 ? _a : []).flatMap(function (p) {
          var _a, _b;
          return [p.provider.providerId, (_b = (_a = p.providerInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ""];
        });
        var haystackParts = __spreadArray(__spreadArray([(_b = model.name) !== null && _b !== void 0 ? _b : "", model.id, model.family], (_c = model.aliases) !== null && _c !== void 0 ? _c : [], true), providerStrings, true);
        var haystack_1 = normalize(haystackParts.join(" "));
        var normalizedQuery = normalize(deferredSearchQuery);
        var containsAllTokens = queryTokens.every(function (t) {
          return haystack_1.includes(t);
        });
        var containsPhrase = normalizedQuery ? haystack_1.includes(normalizedQuery) : true;
        if (!(containsAllTokens || containsPhrase)) {
          return false;
        }
      }
      if (filters.category && filters.category !== "all" && !applyUseCaseFilter(filters.category, model, model.providerDetails.map(function (p) {
        return p.provider;
      }))) {
        return false;
      }
      if (filters.tier === "premium" && !model.premium) {
        return false;
      }
      if (filters.tier === "standard" && model.premium) {
        return false;
      }
      if ((filters.loungePlan === "starter" || filters.loungePlan === "plus") && model.loungePlan !== filters.loungePlan) {
        return false;
      }
      if (filters.capabilities.streaming && !model.providerDetails.some(function (p) {
        return matchesCapability("streaming", p.provider);
      })) {
        return false;
      }
      if (filters.capabilities.vision && !model.providerDetails.some(function (p) {
        return matchesCapability("vision", p.provider);
      })) {
        return false;
      }
      if (filters.capabilities.tools && !model.providerDetails.some(function (p) {
        return matchesCapability("tools", p.provider);
      })) {
        return false;
      }
      if (filters.capabilities.reasoning && !model.providerDetails.some(function (p) {
        return matchesCapability("reasoning", p.provider);
      })) {
        return false;
      }
      if (filters.capabilities.reasoningBudget && !model.providerDetails.some(function (p) {
        return matchesCapability("reasoningMaxTokens", p.provider);
      })) {
        return false;
      }
      if (filters.capabilities.jsonOutput && !model.providerDetails.some(function (p) {
        return matchesCapability("jsonOutput", p.provider);
      })) {
        return false;
      }
      if (filters.capabilities.jsonOutputSchema && !model.providerDetails.some(function (p) {
        return matchesCapability("jsonOutputSchema", p.provider);
      })) {
        return false;
      }
      if (!matchesOutputCapabilities(filters.capabilities, model.output)) {
        return false;
      }
      if (filters.capabilities.webSearch && !model.providerDetails.some(function (p) {
        return matchesCapability("webSearch", p.provider);
      })) {
        return false;
      }
      if (filters.capabilities.free) {
        var hasNonTokenPrice = model.providerDetails.some(function (p) {
          return p.provider.requestPrice && parseFloat(p.provider.requestPrice) > 0 || p.provider.perImagePrice && Object.keys(p.provider.perImagePrice).length > 0 || p.provider.perSecondPrice && Object.keys(p.provider.perSecondPrice).length > 0;
        });
        if (!model.free || hasNonTokenPrice) {
          return false;
        }
      }
      if (filters.capabilities.discounted && !model.providerDetails.some(function (p) {
        return matchesCapability("discounted", p.provider);
      })) {
        return false;
      }
      if (filters.selectedProvider && filters.selectedProvider !== "all") {
        var hasSelectedProvider = model.providerDetails.some(function (p) {
          return p.provider.providerId === filters.selectedProvider;
        });
        if (!hasSelectedProvider) {
          return false;
        }
      }
      var hasInputPrice = function (min, max) {
        return model.providerDetails.some(function (p) {
          return withinBounds(inputPriceInUnit(p.provider, priceUnit), min, max);
        });
      };
      var hasOutputPrice = function (min, max) {
        return model.providerDetails.some(function (p) {
          return withinBounds(outputPriceInUnit(p.provider, priceUnit), min, max);
        });
      };
      var hasContextSize = function (min, max) {
        return model.providerDetails.some(function (p) {
          if (p.provider.contextSize === null || p.provider.contextSize === undefined) {
            return !min && !max;
          }
          var size = p.provider.contextSize;
          var minSize = min ? parseInt(min, 10) : 0;
          var maxSize = max ? parseInt(max, 10) : Infinity;
          return size >= minSize && size <= maxSize;
        });
      };
      if ((filters.inputPrice.min || filters.inputPrice.max) && !hasInputPrice(filters.inputPrice.min, filters.inputPrice.max)) {
        return false;
      }
      if ((filters.outputPrice.min || filters.outputPrice.max) && !hasOutputPrice(filters.outputPrice.min, filters.outputPrice.max)) {
        return false;
      }
      if ((filters.contextSize.min || filters.contextSize.max) && !hasContextSize(filters.contextSize.min, filters.contextSize.max)) {
        return false;
      }
      if (priceUnit && !model.providerDetails.some(function (p) {
        return minUnitPrice(p.provider, priceUnit) !== null;
      })) {
        return false;
      }
      return true;
    });
    if (!sortField) {
      return __spreadArray([], filteredModels, true).sort(compareNewestFirst);
    }
    var sortKey = function (model) {
      var _a, _b, _c, _d, _e, _f;
      switch (sortField) {
        case "provider":
          return ((_e = (_c = (_b = (_a = model.providerDetails[0]) === null || _a === void 0 ? void 0 : _a.providerInfo) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : (_d = model.providerDetails[0]) === null || _d === void 0 ? void 0 : _d.provider.providerId) !== null && _e !== void 0 ? _e : "").toLowerCase();
        case "name":
          return ((_f = model.name) !== null && _f !== void 0 ? _f : model.id).toLowerCase();
        case "inputPrice":
          return minAcross(model.providerDetails, function (p) {
            return inputPriceInUnit(p.provider, priceUnit);
          });
        case "outputPrice":
          return minAcross(model.providerDetails, function (p) {
            return outputPriceInUnit(p.provider, priceUnit);
          });
        case "cachedInputPrice":
          return minAcross(model.providerDetails, function (p) {
            return effectiveTokenPrice(p.provider.cachedInputPrice, p.provider.discount);
          });
        case "discount":
          return Math.max.apply(Math, __spreadArray([0], model.providerDetails.map(function (p) {
            return discountFraction(p.provider.discount);
          }), false));
        default:
          return null;
      }
    };
    return filteredModels.map(function (model) {
      return {
        model: model,
        key: sortKey(model)
      };
    }).sort(function (a, b) {
      return compareSortValues(a.key, b.key, sortDirection);
    }).map(function (_a) {
      var model = _a.model;
      return model;
    });
  }, [deferredSearchQuery, filters, priceUnit, sortField, sortDirection, models, providers, categoryFilter]);
  var filteredProviderCount = useMemo(function () {
    var uniqueProviders = new Set(modelsWithProviders.flatMap(function (model) {
      return model.providerDetails.map(function (p) {
        return p.provider.providerId;
      });
    }));
    return uniqueProviders.size;
  }, [modelsWithProviders]);
  var flattenedRows = useMemo(function () {
    var _a, _b;
    var rows = [];
    var providerFilter = filters.selectedProvider && filters.selectedProvider !== "all" ? filters.selectedProvider : null;
    for (var _i = 0, modelsWithProviders_1 = modelsWithProviders; _i < modelsWithProviders_1.length; _i++) {
      var model = modelsWithProviders_1[_i];
      for (var _c = 0, _d = model.providerDetails; _c < _d.length; _c++) {
        var _e = _d[_c],
          provider = _e.provider,
          providerInfo = _e.providerInfo;
        if (!providerRowPassesFilters(model, provider, {
          providerFilter: providerFilter,
          capabilities: filters.capabilities,
          categoryFilter: categoryFilter,
          category: filters.category
        })) {
          continue;
        }
        if (priceUnit && minUnitPrice(provider, priceUnit) === null) {
          continue;
        }
        var hasAdditionalPricing = provider.webSearch === true || ((_a = parseStrictPrice(provider.requestPrice)) !== null && _a !== void 0 ? _a : 0) > 0 || hasPaidTier(provider.perSecondPrice) || hasPaidTier(provider.perImagePrice);
        rows.push({
          model: model,
          provider: provider,
          providerInfo: providerInfo,
          hasAdditionalPricing: hasAdditionalPricing,
          rowKey: "".concat(provider.providerId, "-").concat(model.id, "-").concat((_b = provider.region) !== null && _b !== void 0 ? _b : ""),
          capabilities: computeCapabilities(provider, model),
          ProviderIcon: getProviderIcon(provider.providerId)
        });
      }
    }
    if (!sortField) {
      return rows.sort(function (a, b) {
        return compareNewestFirst(a.model, b.model) || a.rowKey.localeCompare(b.rowKey);
      });
    }
    var sortKey = function (row) {
      var _a, _b, _c;
      switch (sortField) {
        case "provider":
          return ((_b = (_a = row.providerInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : row.provider.providerId).toLowerCase();
        case "name":
          return ((_c = row.model.name) !== null && _c !== void 0 ? _c : row.model.id).toLowerCase();
        case "inputPrice":
          return inputPriceInUnit(row.provider, priceUnit);
        case "outputPrice":
          return outputPriceInUnit(row.provider, priceUnit);
        case "cachedInputPrice":
          return effectiveTokenPrice(row.provider.cachedInputPrice, row.provider.discount);
        case "discount":
          return discountFraction(row.provider.discount);
        default:
          return null;
      }
    };
    return rows.map(function (row) {
      return {
        row: row,
        key: sortKey(row)
      };
    }).sort(function (a, b) {
      return compareSortValues(a.key, b.key, sortDirection);
    }).map(function (_a) {
      var row = _a.row;
      return row;
    });
  }, [modelsWithProviders, sortField, sortDirection, filters.selectedProvider, priceUnit]);
  var hasActiveFilters = categoryFilter || searchQuery || filters.category && filters.category !== defaultCategory || filters.tier && filters.tier !== "all" || filters.loungePlan !== "all" || Object.values(filters.capabilities).some(Boolean) || filters.selectedProvider && filters.selectedProvider !== "all" || filters.status !== null || filters.source && filters.source !== "all" || filters.eligibleOnly || filters.inputPrice.min || filters.inputPrice.max || filters.outputPrice.min || filters.outputPrice.max || filters.contextSize.min || filters.contextSize.max || priceUnit !== null;
  var currentPage = Math.max(1, Math.floor(Number(searchParams.get("page")) || 1));
  var totalTablePages = Math.ceil(flattenedRows.length / TABLE_ROWS_PER_PAGE);
  var totalGridPages = Math.ceil(modelsWithProviders.length / GRID_MODELS_PER_PAGE);
  var totalPages = viewMode === "table" ? totalTablePages : totalGridPages;
  var safePage = Math.min(currentPage, Math.max(1, totalPages));
  useEffect(function () {
    if (currentPage !== safePage) {
      updateUrlWithFilters({
        page: safePage > 1 ? String(safePage) : undefined
      });
    }
  }, [currentPage, safePage, updateUrlWithFilters]);
  var paginatedFlattenedRows = flattenedRows.slice((safePage - 1) * TABLE_ROWS_PER_PAGE, safePage * TABLE_ROWS_PER_PAGE);
  var paginatedModels = modelsWithProviders.slice((safePage - 1) * GRID_MODELS_PER_PAGE, safePage * GRID_MODELS_PER_PAGE);
  var goToPage = useCallback(function (page) {
    updateUrlWithFilters({
      page: page > 1 ? String(page) : undefined
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [updateUrlWithFilters]);
  var buildPageUrl = useCallback(function (page) {
    var params = new URLSearchParams(searchParams.toString());
    if (page > 1) {
      params.set("page", String(page));
    } else {
      params.delete("page");
    }
    var qs = params.toString();
    return "".concat(pathname).concat(qs ? "?".concat(qs) : "");
  }, [pathname, searchParams]);
  var toggleRowExpanded = useCallback(function (rowKey) {
    setExpandedRows(function (prev) {
      var next = new Set(prev);
      if (next.has(rowKey)) {
        next.delete(rowKey);
      } else {
        next.add(rowKey);
      }
      return next;
    });
  }, []);
  var copyToClipboard = useCallback(function (text, key, e) {
    return __awaiter(_this, void 0, void 0, function () {
      var err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            e.stopPropagation();
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4, navigator.clipboard.writeText(text)];
          case 2:
            _a.sent();
            setCopiedModel(key);
            setTimeout(function () {
              return setCopiedModel(null);
            }, 2000);
            return [3, 4];
          case 3:
            err_1 = _a.sent();
            console.error("Failed to copy text:", err_1);
            return [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, []);
  var openModelPage = useCallback(function (model, path) {
    if (model.source === "custom") {
      return;
    }
    var url = modelHref(path);
    if (modelHrefBase) {
      window.open(url, "_blank");
    } else {
      router.push(url);
    }
  }, [modelHref, modelHrefBase, router]);
  var navigateToRow = useCallback(function (row) {
    return openModelPage(row.model, "/models/".concat(encodeURIComponent(row.model.id), "/").concat(row.provider.providerId));
  }, [openModelPage]);
  var navigateToModel = useCallback(function (model) {
    return openModelPage(model, "/models/".concat(encodeURIComponent(model.id)));
  }, [openModelPage]);
  var handleSort = function (field) {
    if (sortField === field) {
      var newDir = sortDirection === "asc" ? "desc" : "asc";
      setSortDirection(newDir);
      updateUrlWithFilters({
        sortDir: newDir
      });
    } else {
      setSortField(field);
      setSortDirection("asc");
      updateUrlWithFilters({
        sortField: field,
        sortDir: "asc"
      });
    }
  };
  var getSortIcon = function (field) {
    if (sortField !== field) {
      return _jsx(ArrowUpDown, {
        className: "ml-2 h-4 w-4 opacity-50"
      });
    }
    return sortDirection === "asc" ? _jsx(ArrowUp, {
      className: "ml-2 h-4 w-4 text-primary"
    }) : _jsx(ArrowDown, {
      className: "ml-2 h-4 w-4 text-primary"
    });
  };
  var clearFilters = function () {
    setSearchQuery("");
    setFilters({
      category: defaultCategory,
      tier: "all",
      loungePlan: "all",
      capabilities: {
        streaming: false,
        vision: false,
        tools: false,
        reasoning: false,
        reasoningBudget: false,
        jsonOutput: false,
        jsonOutputSchema: false,
        imageGeneration: false,
        videoGeneration: false,
        audioGeneration: false,
        transcription: false,
        embedding: false,
        rerank: false,
        decisions: false,
        searchApi: false,
        webSearch: false,
        free: false,
        discounted: false
      },
      selectedProvider: "all",
      status: null,
      source: "all",
      eligibleOnly: false,
      inputPrice: {
        min: "",
        max: ""
      },
      outputPrice: {
        min: "",
        max: ""
      },
      contextSize: {
        min: "",
        max: ""
      },
      priceUnit: null
    });
    setSortField(null);
    setSortDirection("asc");
    updateUrlWithFilters({
      q: undefined,
      category: undefined,
      tier: undefined,
      lounge: undefined,
      streaming: undefined,
      vision: undefined,
      tools: undefined,
      reasoning: undefined,
      reasoningBudget: undefined,
      jsonOutput: undefined,
      jsonOutputSchema: undefined,
      imageGeneration: undefined,
      videoGeneration: undefined,
      audioGeneration: undefined,
      transcription: undefined,
      embedding: undefined,
      rerank: undefined,
      decisions: undefined,
      searchApi: undefined,
      webSearch: undefined,
      free: undefined,
      discounted: undefined,
      page: undefined,
      provider: undefined,
      status: undefined,
      deactivated: undefined,
      source: undefined,
      eligibility: undefined,
      inputPriceMin: undefined,
      inputPriceMax: undefined,
      outputPriceMin: undefined,
      outputPriceMax: undefined,
      contextSizeMin: undefined,
      contextSizeMax: undefined,
      priceUnit: undefined,
      sortField: undefined,
      sortDir: undefined
    });
  };
  var renderFilters = function () {
    var _a, _b;
    return _jsx(Card, {
      className: "transition-all duration-200 ".concat(showFilters ? "opacity-100" : "opacity-0 hidden"),
      children: _jsx(CardContent, {
        className: "pt-6",
        children: _jsxs("div", {
          className: "grid gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6",
          children: [_jsxs("div", {
            className: "space-y-3",
            children: [!hideUseCaseFilter && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "font-medium text-sm",
                children: "Use Case"
              }), _jsxs(Select, {
                value: filters.category,
                onValueChange: function (value) {
                  var staleKeys = Array.from(new Set(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], getImpliedCapabilityKeys(filters.category), true), getExcludedCapabilityKeys(filters.category), true), getImpliedCapabilityKeys(value), true), getExcludedCapabilityKeys(value), true)));
                  setFilters(function (prev) {
                    var capabilities = __assign({}, prev.capabilities);
                    for (var _i = 0, staleKeys_2 = staleKeys; _i < staleKeys_2.length; _i++) {
                      var key = staleKeys_2[_i];
                      if (key in capabilities) {
                        capabilities[key] = false;
                      }
                    }
                    return __assign(__assign({}, prev), {
                      category: value,
                      capabilities: capabilities
                    });
                  });
                  var urlUpdates = {
                    category: value !== defaultCategory ? value : undefined
                  };
                  for (var _i = 0, staleKeys_1 = staleKeys; _i < staleKeys_1.length; _i++) {
                    var key = staleKeys_1[_i];
                    urlUpdates[key] = undefined;
                  }
                  updateUrlWithFilters(urlUpdates);
                },
                children: [_jsx(SelectTrigger, {
                  className: "w-full",
                  children: _jsx(SelectValue, {
                    placeholder: "All Use Cases"
                  })
                }), _jsxs(SelectContent, {
                  children: [_jsx(SelectItem, {
                    value: "all",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(List, {
                        className: "h-4 w-4 text-muted-foreground"
                      }), "All Use Cases"]
                    })
                  }), _jsx(SelectItem, {
                    value: "code",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Code, {
                        className: "h-4 w-4 text-indigo-500"
                      }), "Code Generation"]
                    })
                  }), _jsx(SelectItem, {
                    value: "chat",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Bot, {
                        className: "h-4 w-4 text-blue-500"
                      }), "Chat & Assistants"]
                    })
                  }), _jsx(SelectItem, {
                    value: "reasoning",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Brain, {
                        className: "h-4 w-4 text-orange-500"
                      }), "Reasoning & Analysis"]
                    })
                  }), _jsx(SelectItem, {
                    value: "creative",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(PenTool, {
                        className: "h-4 w-4 text-purple-500"
                      }), "Creative & Writing"]
                    })
                  }), _jsx(SelectItem, {
                    value: "image",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(ImagePlus, {
                        className: "h-4 w-4 text-pink-500"
                      }), "Image Generation"]
                    })
                  }), _jsx(SelectItem, {
                    value: "multimodal",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Sparkles, {
                        className: "h-4 w-4 text-amber-500"
                      }), "Multimodal (Vision)"]
                    })
                  }), _jsx(SelectItem, {
                    value: "decisions",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(SlidersHorizontal, {
                        className: "h-4 w-4 text-teal-500"
                      }), "Decisions"]
                    })
                  })]
                })]
              })]
            }), showPricingTierFilter ? _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "font-medium text-sm",
                children: "Pricing Tier (DevPass)"
              }), _jsxs(Select, {
                value: filters.tier,
                onValueChange: function (value) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      tier: value
                    });
                  });
                  updateUrlWithFilters({
                    tier: value !== "all" ? value : undefined
                  });
                },
                children: [_jsx(SelectTrigger, {
                  className: "w-full",
                  children: _jsx(SelectValue, {
                    placeholder: "All Tiers"
                  })
                }), _jsxs(SelectContent, {
                  children: [_jsx(SelectItem, {
                    value: "all",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(List, {
                        className: "h-4 w-4 text-muted-foreground"
                      }), "All Tiers"]
                    })
                  }), _jsx(SelectItem, {
                    value: "premium",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Gem, {
                        className: "h-4 w-4 text-amber-500"
                      }), "Premium"]
                    })
                  }), _jsx(SelectItem, {
                    value: "standard",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Zap, {
                        className: "h-4 w-4 text-emerald-500"
                      }), "Standard"]
                    })
                  })]
                })]
              })]
            }) : null, showLoungePlanFilter ? _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "font-medium text-sm",
                children: "Lounge Plan"
              }), _jsxs(Select, {
                value: filters.loungePlan,
                onValueChange: function (value) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      loungePlan: value
                    });
                  });
                  updateUrlWithFilters({
                    lounge: value !== "all" ? value : undefined,
                    page: undefined
                  });
                },
                children: [_jsx(SelectTrigger, {
                  className: "w-full",
                  children: _jsx(SelectValue, {
                    placeholder: "All Plans"
                  })
                }), _jsxs(SelectContent, {
                  children: [_jsx(SelectItem, {
                    value: "all",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(List, {
                        className: "h-4 w-4 text-muted-foreground"
                      }), "All Plans"]
                    })
                  }), _jsx(SelectItem, {
                    value: "starter",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(MessageSquare, {
                        className: "h-4 w-4 text-emerald-500"
                      }), "Included on Starter"]
                    })
                  }), _jsx(SelectItem, {
                    value: "plus",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Sparkles, {
                        className: "h-4 w-4 text-amber-500"
                      }), "Plus & Pro only"]
                    })
                  })]
                })]
              })]
            }) : null]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsx("div", {
              className: "font-medium text-sm",
              children: "Capabilities"
            }), _jsx("div", {
              className: "flex flex-wrap gap-2",
              children: [{
                key: "streaming",
                label: "Streaming",
                icon: Zap,
                color: "text-blue-500"
              }, {
                key: "vision",
                label: "Vision",
                icon: Eye,
                color: "text-green-500"
              }, {
                key: "tools",
                label: "Tools",
                icon: Wrench,
                color: "text-purple-500"
              }, {
                key: "reasoning",
                label: "Reasoning",
                icon: MessageSquare,
                color: "text-orange-500"
              }, {
                key: "reasoningBudget",
                label: "Reasoning Budget",
                icon: Sliders,
                color: "text-amber-500"
              }, {
                key: "jsonOutput",
                label: "JSON",
                icon: Braces,
                color: "text-cyan-500"
              }, {
                key: "jsonOutputSchema",
                label: "Structured JSON",
                icon: FileJson2,
                color: "text-teal-500"
              }, {
                key: "imageGeneration",
                label: "Image Gen",
                icon: ImagePlus,
                color: "text-pink-500"
              }, {
                key: "videoGeneration",
                label: "Video Gen",
                icon: Video,
                color: "text-violet-500"
              }, {
                key: "audioGeneration",
                label: "Speech Gen",
                icon: Volume2,
                color: "text-rose-500"
              }, {
                key: "transcription",
                label: "Transcription",
                icon: Mic,
                color: "text-sky-500"
              }, {
                key: "embedding",
                label: "Embeddings",
                icon: Boxes,
                color: "text-indigo-500"
              }, {
                key: "rerank",
                label: "Rerank",
                icon: ListOrdered,
                color: "text-amber-500"
              }, {
                key: "decisions",
                label: "Decisions",
                icon: SlidersHorizontal,
                color: "text-teal-500"
              }, {
                key: "searchApi",
                label: "Search API",
                icon: Search,
                color: "text-sky-500"
              }, {
                key: "webSearch",
                label: "Web Search",
                icon: Globe,
                color: "text-sky-500"
              }, {
                key: "free",
                label: "Free",
                icon: Gift,
                color: "text-emerald-500"
              }, {
                key: "discounted",
                label: "Discounted",
                icon: Percent,
                color: "text-red-500"
              }].map(function (_a) {
                var key = _a.key,
                  label = _a.label,
                  Icon = _a.icon,
                  color = _a.color;
                var isImplied = impliedCapabilityKeys.includes(key);
                var isExcluded = excludedCapabilityKeys.includes(key);
                var toggle = _jsxs(Toggle, {
                  variant: "outline",
                  size: "sm",
                  disabled: isImplied || isExcluded,
                  pressed: !isExcluded && (isImplied || filters.capabilities[key]),
                  onPressedChange: function (pressed) {
                    var _a, _b, _c;
                    setFilters(function (prev) {
                      var _a;
                      return __assign(__assign({}, prev), {
                        capabilities: __assign(__assign({}, prev.capabilities), (_a = {}, _a[key] = pressed, _a))
                      });
                    });
                    if (key === "discounted") {
                      if (pressed) {
                        setSortField("discount");
                        setSortDirection("desc");
                        updateUrlWithFilters((_a = {}, _a[key] = "true", _a.sortField = "discount", _a.sortDir = "desc", _a));
                      } else {
                        setSortField(null);
                        setSortDirection("desc");
                        updateUrlWithFilters((_b = {}, _b[key] = undefined, _b.sortField = undefined, _b.sortDir = undefined, _b));
                      }
                    } else {
                      updateUrlWithFilters((_c = {}, _c[key] = pressed ? "true" : undefined, _c));
                    }
                  },
                  className: "gap-1.5",
                  children: [_jsx(Icon, {
                    className: "h-3.5 w-3.5 ".concat(color)
                  }), _jsx("span", {
                    className: "text-xs",
                    children: label
                  })]
                }, "".concat(key, "-").concat(label));
                return isImplied || isExcluded ? _jsxs(Tooltip, {
                  children: [_jsx(TooltipTrigger, {
                    asChild: true,
                    children: _jsx("span", {
                      tabIndex: 0,
                      children: toggle
                    })
                  }), _jsx(TooltipContent, {
                    children: _jsx("p", {
                      className: "text-xs",
                      children: isImplied ? "Already included in the selected category" : "No models in the selected category can match this"
                    })
                  })]
                }, "".concat(key, "-").concat(label)) : toggle;
              })
            })]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsx("div", {
              className: "font-medium text-sm",
              children: "Provider"
            }), _jsxs(Select, {
              value: filters.selectedProvider,
              onValueChange: function (value) {
                setFilters(function (prev) {
                  return __assign(__assign({}, prev), {
                    selectedProvider: value
                  });
                });
                updateUrlWithFilters({
                  provider: value === "all" ? undefined : value
                });
              },
              children: [_jsx(SelectTrigger, {
                className: "w-full",
                children: _jsx(SelectValue, {
                  placeholder: "All providers"
                })
              }), _jsxs(SelectContent, {
                children: [_jsx(SelectItem, {
                  value: "all",
                  children: "All providers"
                }), providers.map(function (provider) {
                  var ProviderIcon = getProviderIcon(provider.id);
                  return _jsx(SelectItem, {
                    value: provider.id,
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [ProviderIcon && _jsx(ProviderIcon, {
                        className: "h-4 w-4"
                      }), _jsx("span", {
                        children: provider.name
                      })]
                    })
                  }, "".concat(provider.id, "-").concat(provider.name));
                })]
              })]
            }), hasCustomModels && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "font-medium text-sm",
                children: "Source"
              }), _jsxs(Select, {
                value: filters.source,
                onValueChange: function (value) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      source: value
                    });
                  });
                  updateUrlWithFilters({
                    source: value === "all" ? undefined : value,
                    page: undefined
                  });
                },
                children: [_jsx(SelectTrigger, {
                  className: "w-full",
                  children: _jsx(SelectValue, {
                    placeholder: "All models"
                  })
                }), _jsxs(SelectContent, {
                  children: [_jsx(SelectItem, {
                    value: "all",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(List, {
                        className: "h-4 w-4 text-muted-foreground"
                      }), "Catalog & custom"]
                    })
                  }), _jsx(SelectItem, {
                    value: "catalog",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Boxes, {
                        className: "h-4 w-4 text-indigo-500"
                      }), "Catalog models"]
                    })
                  }), _jsx(SelectItem, {
                    value: "custom",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Wrench, {
                        className: "h-4 w-4 text-emerald-500"
                      }), "Custom models"]
                    })
                  })]
                })]
              })]
            }), _jsx("div", {
              className: "font-medium text-sm",
              children: "Status"
            }), _jsxs("div", {
              className: "flex flex-col items-start gap-1.5",
              children: [_jsxs(Tooltip, {
                children: [_jsx(TooltipTrigger, {
                  asChild: true,
                  children: _jsx("span", {
                    children: _jsxs(Toggle, {
                      variant: "outline",
                      size: "sm",
                      pressed: filters.status === "deactivated",
                      onPressedChange: function (pressed) {
                        setStatusFilter(pressed ? "deactivated" : null);
                      },
                      className: "gap-1.5 w-fit",
                      children: [_jsx(AlertCircle, {
                        className: "h-3.5 w-3.5 text-red-500"
                      }), _jsx("span", {
                        className: "text-xs",
                        children: "Deactivated"
                      })]
                    })
                  })
                }), _jsx(TooltipContent, {
                  children: _jsx("p", {
                    className: "text-xs",
                    children: "Dead / requests return errors and no longer route"
                  })
                })]
              }), _jsxs(Tooltip, {
                children: [_jsx(TooltipTrigger, {
                  asChild: true,
                  children: _jsx("span", {
                    children: _jsxs(Toggle, {
                      variant: "outline",
                      size: "sm",
                      pressed: filters.status === "scheduled",
                      onPressedChange: function (pressed) {
                        setStatusFilter(pressed ? "scheduled" : null);
                      },
                      className: "gap-1.5 w-fit",
                      children: [_jsx(Clock, {
                        className: "h-3.5 w-3.5 text-amber-500"
                      }), _jsx("span", {
                        className: "text-xs",
                        children: "Scheduled"
                      })]
                    })
                  })
                }), _jsx(TooltipContent, {
                  children: _jsx("p", {
                    className: "text-xs",
                    children: "Still works / deactivation scheduled within 90 days, plan to migrate"
                  })
                })]
              }), _jsxs(Tooltip, {
                children: [_jsx(TooltipTrigger, {
                  asChild: true,
                  children: _jsx("span", {
                    children: _jsxs(Toggle, {
                      variant: "outline",
                      size: "sm",
                      pressed: filters.status === "deprecated",
                      onPressedChange: function (pressed) {
                        setStatusFilter(pressed ? "deprecated" : null);
                      },
                      className: "gap-1.5 w-fit",
                      children: [_jsx(AlertTriangle, {
                        className: "h-3.5 w-3.5 text-amber-500"
                      }), _jsx("span", {
                        className: "text-xs",
                        children: "Deprecated"
                      })]
                    })
                  })
                }), _jsx(TooltipContent, {
                  children: _jsx("p", {
                    className: "text-xs",
                    children: "Still works / provider announced sunset, migrate soon"
                  })
                })]
              }), hasBlockedMappings && _jsxs(Toggle, {
                variant: "outline",
                size: "sm",
                pressed: filters.eligibleOnly,
                onPressedChange: function (pressed) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      eligibleOnly: pressed
                    });
                  });
                  updateUrlWithFilters({
                    eligibility: pressed ? "eligible" : undefined,
                    page: undefined
                  });
                },
                className: "gap-1.5",
                children: [_jsx(Check, {
                  className: "h-3.5 w-3.5 text-emerald-500"
                }), _jsx("span", {
                  className: "text-xs",
                  children: "Eligible only"
                })]
              })]
            })]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsxs("div", {
              className: "font-medium text-sm",
              children: ["Input Price (", (_a = priceUnitOption === null || priceUnitOption === void 0 ? void 0 : priceUnitOption.unit) !== null && _a !== void 0 ? _a : "$/M tokens", ")"]
            }), _jsxs("div", {
              className: "space-y-2",
              children: [_jsx(Input, {
                placeholder: "Min price",
                type: "number",
                value: filters.inputPrice.min,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      inputPrice: __assign(__assign({}, prev.inputPrice), {
                        min: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    inputPriceMin: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              }), _jsx(Input, {
                placeholder: "Max price",
                type: "number",
                value: filters.inputPrice.max,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      inputPrice: __assign(__assign({}, prev.inputPrice), {
                        max: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    inputPriceMax: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              })]
            }), hasPerUnitData && _jsxs("div", {
              className: "space-y-2",
              children: [_jsx("div", {
                className: "font-medium text-sm",
                children: "Price per unit"
              }), _jsx("div", {
                className: "flex w-fit flex-col gap-1.5",
                children: PRICE_UNIT_OPTIONS.map(function (_a) {
                  var field = _a.field,
                    Icon = _a.Icon,
                    iconClass = _a.iconClass,
                    name = _a.name,
                    unit = _a.unit;
                  return _jsxs(Toggle, {
                    variant: "outline",
                    size: "sm",
                    pressed: priceUnit === field,
                    onPressedChange: function (pressed) {
                      var next = pressed ? field : null;
                      setFilters(function (prev) {
                        return __assign(__assign({}, prev), {
                          priceUnit: next,
                          inputPrice: {
                            min: "",
                            max: ""
                          },
                          outputPrice: {
                            min: "",
                            max: ""
                          }
                        });
                      });
                      updateUrlWithFilters({
                        priceUnit: next !== null && next !== void 0 ? next : undefined,
                        inputPriceMin: undefined,
                        inputPriceMax: undefined,
                        outputPriceMin: undefined,
                        outputPriceMax: undefined,
                        page: undefined
                      });
                    },
                    className: "gap-1.5 w-fit justify-start",
                    children: [_jsx(Icon, {
                      className: "h-3.5 w-3.5 ".concat(iconClass)
                    }), _jsxs("span", {
                      className: "text-xs",
                      children: [name, " ", unit]
                    })]
                  }, field);
                })
              })]
            })]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsxs("div", {
              className: "font-medium text-sm",
              children: ["Output Price (", (_b = priceUnitOption === null || priceUnitOption === void 0 ? void 0 : priceUnitOption.unit) !== null && _b !== void 0 ? _b : "$/M tokens", ")"]
            }), _jsxs("div", {
              className: "space-y-2",
              children: [_jsx(Input, {
                placeholder: "Min price",
                type: "number",
                value: filters.outputPrice.min,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      outputPrice: __assign(__assign({}, prev.outputPrice), {
                        min: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    outputPriceMin: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              }), _jsx(Input, {
                placeholder: "Max price",
                type: "number",
                value: filters.outputPrice.max,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      outputPrice: __assign(__assign({}, prev.outputPrice), {
                        max: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    outputPriceMax: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              })]
            })]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsx("div", {
              className: "font-medium text-sm",
              children: "Context Size (tokens)"
            }), _jsxs("div", {
              className: "space-y-2",
              children: [_jsx(Input, {
                placeholder: "Min size (e.g., 128000)",
                type: "number",
                value: filters.contextSize.min,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      contextSize: __assign(__assign({}, prev.contextSize), {
                        min: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    contextSizeMin: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              }), _jsx(Input, {
                placeholder: "Max size (e.g., 200000)",
                type: "number",
                value: filters.contextSize.max,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      contextSize: __assign(__assign({}, prev.contextSize), {
                        max: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    contextSizeMax: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              })]
            })]
          })]
        })
      })
    });
  };
  var impliedCapabilityKeys = useMemo(function () {
    return getImpliedCapabilityKeys(filters.category, categoryFilter);
  }, [filters.category, categoryFilter]);
  var excludedCapabilityKeys = useMemo(function () {
    return getExcludedCapabilityKeys(filters.category);
  }, [filters.category]);
  var pinnedCapabilityKeys = useMemo(function () {
    var explicitKeys = Object.entries(filters.capabilities).filter(function (_a) {
      var pressed = _a[1];
      return pressed;
    }).map(function (_a) {
      var key = _a[0];
      return key;
    }).filter(function (key) {
      return CAPABILITY_LABEL_BY_FILTER_KEY[key];
    });
    return Array.from(new Set(__spreadArray(__spreadArray([], explicitKeys, true), impliedCapabilityKeys, true)));
  }, [filters.capabilities, impliedCapabilityKeys]);
  var renderTableView = function () {
    var _a, _b;
    return _jsx("div", {
      className: "rounded-md border",
      children: _jsx("div", {
        className: "relative w-full overflow-x-auto",
        children: _jsxs(Table, {
          children: [_jsx(TableHeader, {
            className: "top-0 z-10 bg-background/95 backdrop-blur",
            children: _jsxs(TableRow, {
              children: [_jsx(TableHead, {
                className: "w-[180px] bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("provider");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent justify-start uppercase text-xs tracking-wider",
                  children: ["Provider", getSortIcon("provider")]
                })
              }), _jsx(TableHead, {
                className: "w-[280px] bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("name");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent justify-start uppercase text-xs tracking-wider",
                  children: ["Model ID", getSortIcon("name")]
                })
              }), _jsx(TableHead, {
                className: "text-right bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("inputPrice");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent uppercase text-xs tracking-wider",
                  children: ["Input ", (_a = priceUnitOption === null || priceUnitOption === void 0 ? void 0 : priceUnitOption.unit) !== null && _a !== void 0 ? _a : "$/M", getSortIcon("inputPrice")]
                })
              }), _jsx(TableHead, {
                className: "text-right bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("outputPrice");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent uppercase text-xs tracking-wider",
                  children: ["Output ", (_b = priceUnitOption === null || priceUnitOption === void 0 ? void 0 : priceUnitOption.unit) !== null && _b !== void 0 ? _b : "$/M", getSortIcon("outputPrice")]
                })
              }), _jsx(TableHead, {
                className: "text-right bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("cachedInputPrice");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent uppercase text-xs tracking-wider",
                  children: ["Cache Read $/M", getSortIcon("cachedInputPrice")]
                })
              }), _jsx(TableHead, {
                className: "text-center bg-background/95 backdrop-blur-sm border-b uppercase text-xs tracking-wider font-semibold",
                children: "Features"
              })]
            })
          }), _jsx(TableBody, {
            children: paginatedFlattenedRows.map(function (row) {
              return _jsx(ModelTableRow, {
                row: row,
                isExpanded: expandedRows.has(row.rowKey),
                copiedModel: copiedModel,
                onToggleExpand: toggleRowExpanded,
                onCopy: copyToClipboard,
                onNavigate: navigateToRow,
                formatPrice: formatPrice,
                modelHref: modelHref,
                pinnedCapabilityKeys: pinnedCapabilityKeys,
                showLoungePlan: showLoungePlanFilter
              }, row.rowKey);
            })
          })]
        })
      })
    });
  };
  var renderGridView = function () {
    return _jsx("div", {
      className: "grid gap-6 md:grid-cols-2 lg:grid-cols-3",
      children: paginatedModels.map(function (model) {
        var _a;
        return _jsx(GridModelCard, {
          model: model,
          onNavigate: navigateToModel,
          renderCta: renderCta
        }, "".concat(model.id, "-").concat(model.providerDetails[0].provider.providerId, "-").concat((_a = model.providerDetails[0].provider.region) !== null && _a !== void 0 ? _a : ""));
      })
    });
  };
  return _jsxs("div", {
    className: "min-h-screen text-foreground bg-background",
    children: [totalPages > 1 && _jsxs(_Fragment, {
      children: [safePage > 1 && _jsx("link", {
        rel: "prev",
        href: buildPageUrl(safePage - 1)
      }), safePage < totalPages && _jsx("link", {
        rel: "next",
        href: buildPageUrl(safePage + 1)
      })]
    }), _jsxs("main", {
      children: [children, _jsx("div", {
        className: cn("container mx-auto px-4 pb-8 space-y-6", {
          "pt-40": children
        }),
        children: _jsx(TooltipProvider, {
          delayDuration: 300,
          skipDelayDuration: 100,
          children: _jsxs("div", {
            className: "container mx-auto py-8 space-y-6",
            children: [!hideHeader && _jsxs("div", {
              className: "flex items-start md:items-center justify-between flex-col md:flex-row gap-4",
              children: [_jsxs("div", {
                children: [_jsx("h1", {
                  className: "text-3xl font-bold",
                  children: title !== null && title !== void 0 ? title : "Models"
                }), _jsx("p", {
                  className: "text-muted-foreground mt-2",
                  children: description !== null && description !== void 0 ? description : "Comprehensive list of all supported models and their providers"
                })]
              }), _jsxs("div", {
                className: "flex items-center gap-2",
                children: [_jsx(Link, {
                  href: "https://docs.llmgateway.io/v1_models",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: _jsxs(Button, {
                    variant: "outline",
                    size: "sm",
                    children: [_jsx(ExternalLink, {
                      className: "h-4 w-4 mr-1"
                    }), "API Docs"]
                  })
                }), _jsx(Button, {
                  size: "sm",
                  asChild: true,
                  children: _jsxs(Link, {
                    href: modelHref("/models/compare"),
                    children: [_jsx(Scale, {
                      className: "h-4 w-4 mr-1"
                    }), "Compare"]
                  })
                })]
              })]
            }), _jsxs("div", {
              className: "flex flex-col gap-4",
              children: [_jsxs("div", {
                className: "flex items-center gap-4",
                children: [_jsxs("div", {
                  className: "relative flex-1 max-w-sm",
                  children: [_jsx(Search, {
                    className: "absolute left-2 top-2.5 h-4 w-4 text-muted-foreground"
                  }), _jsx(Input, {
                    placeholder: "Search models...",
                    value: searchQuery,
                    onChange: function (e) {
                      var value = e.target.value;
                      setSearchQuery(value);
                      updateUrlWithFilters({
                        q: value,
                        page: undefined
                      });
                    },
                    className: "pl-8"
                  })]
                }), _jsxs(Button, {
                  variant: "outline",
                  size: "sm",
                  onClick: function () {
                    var next = !showFilters;
                    setShowFilters(next);
                    updateUrlWithFilters({
                      filters: next ? "1" : undefined
                    });
                  },
                  className: hasActiveFilters ? "border-primary text-primary" : "",
                  children: [_jsx(Filter, {
                    className: "h-4 w-4 mr-1"
                  }), "Filters", hasActiveFilters && _jsx(Badge, {
                    variant: "secondary",
                    className: "ml-2 px-1 py-0 text-xs",
                    children: [categoryFilter ? 1 : 0, searchQuery ? 1 : 0, filters.category && filters.category !== defaultCategory ? 1 : 0, filters.tier && filters.tier !== "all" ? 1 : 0, filters.loungePlan !== "all" ? 1 : 0, filters.selectedProvider && filters.selectedProvider !== "all" ? 1 : 0, Object.values(filters.capabilities).filter(Boolean).length, filters.status ? 1 : 0, filters.source && filters.source !== "all" ? 1 : 0, filters.eligibleOnly ? 1 : 0, [filters.inputPrice.min, filters.inputPrice.max].filter(Boolean).length, [filters.outputPrice.min, filters.outputPrice.max].filter(Boolean).length, [filters.contextSize.min, filters.contextSize.max].filter(Boolean).length, priceUnit ? 1 : 0].reduce(function (a, b) {
                      return a + b;
                    }, 0)
                  })]
                }), hasActiveFilters && _jsxs(Button, {
                  variant: "ghost",
                  size: "sm",
                  onClick: clearFilters,
                  children: [_jsx(X, {
                    className: "h-4 w-4 mr-1"
                  }), "Clear"]
                })]
              }), renderFilters()]
            }), _jsxs("div", {
              className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4",
              children: [_jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: hasActiveFilters ? "".concat(modelsWithProviders.length, "/").concat(totalModelCount) : modelsWithProviders.length
                  }), _jsx("div", {
                    className: "text-sm text-muted-foreground",
                    children: "Models"
                  })]
                })
              }), _jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: hasActiveFilters ? "".concat(filteredProviderCount, "/").concat(totalProviderCount) : totalProviderCount
                  }), _jsx("div", {
                    className: "text-sm text-muted-foreground",
                    children: "Providers"
                  })]
                })
              }), _jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: modelsWithProviders.filter(function (m) {
                      return m.providerDetails.some(function (p) {
                        return p.provider.vision;
                      });
                    }).length
                  }), _jsxs("div", {
                    className: "text-sm text-muted-foreground",
                    children: ["Vision Models", hasActiveFilters ? " (filtered)" : ""]
                  })]
                })
              }), _jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: modelsWithProviders.filter(function (m_0) {
                      return m_0.providerDetails.some(function (p_0) {
                        return p_0.provider.tools;
                      });
                    }).length
                  }), _jsxs("div", {
                    className: "text-sm text-muted-foreground",
                    children: ["Tool-enabled", hasActiveFilters ? " (filtered)" : ""]
                  })]
                })
              }), _jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: modelsWithProviders.filter(function (m_1) {
                      return m_1.free;
                    }).length
                  }), _jsxs("div", {
                    className: "text-sm text-muted-foreground",
                    children: ["Free Models", hasActiveFilters ? " (filtered)" : ""]
                  })]
                })
              })]
            }), _jsxs("div", {
              className: "flex items-center gap-2",
              children: [_jsxs(Button, {
                variant: viewMode === "table" ? "default" : "outline",
                size: "sm",
                onClick: function () {
                  setViewMode("table");
                  updateUrlWithFilters({
                    view: "table"
                  });
                },
                children: [_jsx(List, {
                  className: "h-4 w-4 mr-1"
                }), "Table"]
              }), _jsxs(Button, {
                variant: viewMode === "grid" ? "default" : "outline",
                size: "sm",
                onClick: function () {
                  setViewMode("grid");
                  updateUrlWithFilters({
                    view: "grid"
                  });
                },
                children: [_jsx(Grid, {
                  className: "h-4 w-4 mr-1"
                }), "Grid"]
              })]
            }), viewMode === "table" ? renderTableView() : renderGridView(), totalPages > 1 && _jsxs("nav", {
              "aria-label": "Pagination",
              className: "flex items-center justify-center gap-2 pt-4",
              children: [_jsxs(Button, {
                variant: "outline",
                size: "sm",
                disabled: safePage <= 1,
                onClick: function () {
                  return goToPage(safePage - 1);
                },
                children: [_jsx(ChevronLeft, {
                  className: "h-4 w-4 mr-1"
                }), "Previous"]
              }), _jsxs("span", {
                className: "text-sm text-muted-foreground px-2",
                children: ["Page ", safePage, " of ", totalPages]
              }), _jsxs(Button, {
                variant: "outline",
                size: "sm",
                disabled: safePage >= totalPages,
                onClick: function () {
                  return goToPage(safePage + 1);
                },
                children: ["Next", _jsx(ChevronRight, {
                  className: "h-4 w-4 ml-1"
                })]
              })]
            })]
          })
        })
      }), seoContent]
    }), footer]
  });
}